<div class="chart" *ngIf="data">
  <canvas baseChart [chartType]="type" [options]="options" [labels]="data.labels" [datasets]="data.datasets"
    [colors]="colors"></canvas>
</div>
